import { useMemo } from 'react'
import { useQuery, useMutation } from '@tanstack/react-query'
import { fetchStandbySchedulingSlots, fetchFulfilledSchedulingSlotIds, scheduleStandbyAppointmentSlot } from './api'

export const useStandbyScheduleSlots = ({ linkId }) => {
  const { data: standbyScheduleData = { slots: {} }, isLoading, isError } = useQuery({
    queryKey: ['fetchStandbySchedulingSlots', linkId],
    queryFn: () => fetchStandbySchedulingSlots({ linkId }),
    retry: false,
    throwOnError: false
  })

  const isSchedulingLinkExpired = useMemo(() => standbyScheduleData.linkStatus === 'EXPIRED', [standbyScheduleData])

  const isSchedulingLinkInvalid = useMemo(() => isError || standbyScheduleData.linkStatus === 'INVALID', [isError, standbyScheduleData])

  const isSchedulingLinkUsed = useMemo(() => standbyScheduleData.linkStatus === 'USED', [standbyScheduleData])

  const isSchedulingLinkDisabled = useMemo(() => standbyScheduleData.linkStatus === 'DISABLED', [standbyScheduleData])

  return {
    schedulingData: standbyScheduleData ?? {},
    isSchedulingLinkInvalid,
    isSchedulingLinkUsed,
    isSchedulingLinkDisabled,
    isSchedulingLinkExpired,
    isLoadingSlots: isLoading
  }
}

export const useFetchFulfilledSlots = ({ linkId }) => {
  const { data: fulfilledSlotIds = [] } = useQuery({
    queryKey: ['fetchFulfilledSlotIds', linkId],
    queryFn: () => fetchFulfilledSchedulingSlotIds({ linkId }),
    refetchInterval: 10000
  })

  return {
    fulfilledSlotIds
  }
}

export const useScheduleStandbySlot = ({ linkId }) => {
  const scheduleStandbySlotMutation = useMutation({
    mutationFn: ({ cohortId, slotId }) => {
      return scheduleStandbyAppointmentSlot({ linkId, cohortId, slotId })
    }
  })

  return {
    scheduleStandbySlot: scheduleStandbySlotMutation
  }
}
